import { parse } from 'date-fns';
import formatDateStringNoTimezone from './formatDateStringNoTimezone';
/**
 * Formats 'yyyy-MM-dd' date to a Date object
 * @param dateString
 */
const formatDateStringToObject = (dateString) => {
    return parse(formatDateStringNoTimezone(dateString), 'yyyy-MM-dd', new Date());
};
export default formatDateStringToObject;
